<template>
    <div>
        <div class="row">
           

            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Korisnici</h3>
                    </template>
                    <base-button class="mt-3" native-type="submit" type="primary"
                        @click="user = {}; editUserDialog = true">Novi
                        korisnik</base-button>

                    <el-table :data="users" v-loading="usersLoading">
                        <el-table-column min-width="150" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150" prop="userName" label="Korisničko ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="role" label="Rola">
                            <template slot-scope="scope">
                                <span>{{ scope.row.role.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="200" prop="role" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.active" style="color: cadetblue;" >AKTIVAN</span>
                                <span v-else style="color: red;" >NIJE AKTIVAN</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Dozvole" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" size="sm" class="btn-link"
                                        @click="user = scope.row; getUserPages()">
                                            Dozvole                                    
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; editUserDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; deleteUserPrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
        
        <modal :show.sync="editUserDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editUserDialog = false; user = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">Korisnik</h4>
                <form @submit.prevent>
                    <div>
                        <base-input label="Ime i prezime" type="text" v-model="user.name"
                            placeholder="Ime i prezime">
                        </base-input>
                        <base-input label="Korisničko ime" type="text" v-model="user.userName"
                            placeholder="Korisničko ime">
                        </base-input>
                        <base-input label="Lozinka (Ukoliko ne menjate lozinku, ostavite prazno)" type="password"
                            v-model="user.password" placeholder="Password">
                        </base-input>
                        <base-input label="Rola" placeholder="Rola">
                            <el-select v-model="user.role" class="select-primary" name="role" value-key="id">
                                <el-option v-for="role in roles" class="select-primary" :label="role.name" :value="role"
                                    :key="role.id"></el-option>
                            </el-select>
                        </base-input>
                        
                        <div class="form-group">
                            <base-checkbox v-model="user.active">Aktivan</base-checkbox>
                        </div>
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveUser()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3" @click="editUserDialog = false; user = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>

        <modal :show.sync="showUserPages" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showUserPages = false; user = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stranice">
                <el-table :data="userPages" v-loading="usersLoading">
                        <el-table-column min-width="150" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" prop="name" label="">
                            <template slot-scope="scope">
                                <span><base-checkbox class="text-left" v-model="scope.row.checked" @changed="updatePage(scope.row)">
                                    
                                </base-checkbox></span>
                            </template>
                        </el-table-column>
                        
                        

                        <!-- <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; editUserDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; deleteUserPrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column> -->
                    </el-table>
            </card>

        </modal>

        
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getUsers()
        this.getRoles()
        this.getPages()
    },
    data() {
        return {
            activeName: 'first',
            url: 'https://budva.scancar.org:8443/kuca',
            
            users: [],
            user: {},
            usersLoading: false,
            
            user: {},
            editUserDialog: false,
            roles: [],
            showUserPages: false,
            pages: [],
            userPages: []
        };
    },
    methods: {
        updatePage(page){
            axios.post(this.url + '/user/updatePage', page).then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getUserPages(){
            axios.get(this.url + '/user/getUserPages?id='+this.user.id).then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.userPages = result.data.pages
                    this.showUserPages = true
                } else {

                }
            })
        },
        getPages(){
            axios.get(this.url + '/user/getPages').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.pages = result.data.pages
                } else {

                }
            })
        },
        getRoles() {
            // this.zonesLoading = true
            axios.get(this.url + '/settings/getRoles').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.roles = result.data.roles
                } else {

                }
            })
        },
        
        getUsers() {
            this.usersLoading = true
            axios.get(this.url + '/user/getUsers').then(result => {
                this.usersLoading = false

                if (result.data.result === 'ok') {
                    this.users = result.data.users
                } else {

                }
            })
        },
        saveUser() {
            this.loading = true
            axios.post(this.url + '/user/saveUser', this.user).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editUserDialog = false
                    this.getUsers()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        
        deleteUser() {
            this.loading = true
            axios.get(this.url + '/user/deleteUser?id=' + this.user.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getUsers()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        
        
        deleteUserPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete korisnika \"" + this.user.userName + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteUser()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>